import { Menu, Transition } from '@headlessui/react'
import { Fragment, useRef } from 'react'
import { Form, Link } from 'react-router'
import { UserAvatar } from '#app/components/user-avatar.tsx'
import { cn } from '#app/utils/misc.tsx'
import {
	getUserDisplayName,
	getUserRoleLabel,
} from '#app/utils/user-display.ts'
import { useOptionalUser } from '#app/utils/user.ts'

export function UserDropdown() {
	const user = useOptionalUser()
	const formRef = useRef<HTMLFormElement>(null)

	if (!user) return null

	const displayName = getUserDisplayName(user.name, user.username)
	const roleLabel = getUserRoleLabel(user.roles)

	return (
		<Menu as="div" className="relative ml-3">
			<div>
				<Menu.Button className="relative flex items-center gap-3 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-navbar">
					<span className="absolute -inset-1.5" />
					<span className="sr-only">Abrir menú de usuario</span>
					<UserAvatar
						userId={user.id}
						imageId={user.image?.id}
						name={user.name}
						username={user.username}
						className="h-10 w-10 text-sm"
					/>
					<span className="hidden min-w-0 text-left sm:block">
						<span className="block truncate font-semibold text-navbar-foreground">
							{displayName}
						</span>
						{roleLabel ? (
							<span className="block truncate text-xs text-navbar-foreground/70">
								{roleLabel}
							</span>
						) : null}
					</span>
				</Menu.Button>
			</div>
			<Transition
				as={Fragment}
				enter="transition ease-out duration-100"
				enterFrom="transform opacity-0 scale-95"
				enterTo="transform opacity-100 scale-100"
				leave="transition ease-in duration-75"
				leaveFrom="transform opacity-100 scale-100"
				leaveTo="transform opacity-0 scale-95"
			>
				<Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
					{user.organizations?.length && user.organizations.length > 1 ? (
						<Menu.Item>
							{({ active }) => (
								<Link
									prefetch="intent"
									to="/switch-organization"
									className={cn(
										active ? 'bg-gray-100' : '',
										'block px-4 py-2 text-sm text-gray-700',
									)}
								>
									Cambiar organización
								</Link>
							)}
						</Menu.Item>
					) : null}
					<Menu.Item>
						{({ active }) => (
							<Link
								prefetch="intent"
								to={`/users/${user.username}/edit`}
								className={cn(
									active ? 'bg-gray-100' : '',
									'block px-4 py-2 text-sm text-gray-700',
								)}
							>
								Perfil
							</Link>
						)}
					</Menu.Item>
					<Menu.Item>
						{({ active }) => (
							<Form action="/logout" method="POST" ref={formRef}>
								<button
									type="submit"
									className={cn(
										active ? 'bg-gray-100' : '',
										'block w-full px-4 py-2 text-start text-sm text-gray-700',
									)}
								>
									Cerrar sesión
								</button>
							</Form>
						)}
					</Menu.Item>
				</Menu.Items>
			</Transition>
		</Menu>
	)
}
